import React, { memo } from 'react';
import '@xyflow/react/dist/style.css';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { getGenreColors } from '../../../utils/genreColors';
export const GenreNode = memo(({
  data,
  selected
}: NodeProps) => {
  const {
    name,
    colorKey,
    type,
    isDarkMode
  } = data as {
    name: string;
    colorKey: string;
    type: 'genre' | 'romance_subgenre' | 'story_engine';
    isDarkMode?: boolean;
  };
  const colors = getGenreColors(colorKey);
  const isGenre = type === 'genre';
  const isSubgenre = type === 'romance_subgenre';
  const isEngine = type === 'story_engine';
  // Determine shape and sizing based on node type
  const shapeClasses = isGenre ? 'px-8 py-4 rounded-full border-4' : isSubgenre ? 'px-6 py-3 rounded-full border-2' : 'px-5 py-2.5 rounded-xl border-2 border-dashed';
  return <div className={`relative group cursor-pointer transition-all duration-300 ${selected ? 'scale-110' : 'hover:scale-105'}`} data-id="element-14747" data-mp="14pri9ht1q376">
      {/* Glow effect */}
      <div className={`absolute inset-0 rounded-full blur-xl transition-opacity duration-300 ${selected ? 'opacity-60' : 'opacity-20 group-hover:opacity-40'}`} style={{
      backgroundColor: colors.bg
    }} data-id="element-14748" data-mp="3go5ymly77yhm" />

      {/* Node Body */}
      <div className={`relative flex flex-col items-center justify-center shadow-lg backdrop-blur-sm transition-all ${shapeClasses}`} style={{
      backgroundColor: isDarkMode ? '#111827' : '#ffffff',
      borderColor: selected ? colors.bgLight : isDarkMode ? colors.bgDark : colors.bg,
      boxShadow: selected ? `0 0 20px ${colors.bg}40` : 'none'
    }} data-id="element-14749" data-mp="3qgblxidi9rqh">
        <span className={`${isGenre ? 'text-base' : 'text-sm'} font-bold whitespace-nowrap`} style={{
        color: isDarkMode ? '#ffffff' : '#111827'
      }} data-id="element-14750" data-mp="32o3h50tsz72w">
          {name}
        </span>
        {isGenre && <span className="text-[10px] font-medium mt-0.5 uppercase tracking-wider" style={{
        color: isDarkMode ? '#9ca3af' : '#6b7280'
      }} data-id="element-14751" data-mp="p1voyz5ypgkc">
            Primary Genre
          </span>}
      </div>

      {/* Handles for edges (invisible but functional) */}
      <Handle type="target" position={Position.Top} className="opacity-0" data-id="element-14752" data-mp="13zee42mjxvsb" />
      <Handle type="source" position={Position.Bottom} className="opacity-0" data-id="element-14753" data-mp="6bmfr5brcoj5" />
      <Handle type="target" position={Position.Left} className="opacity-0" data-id="element-14754" data-mp="69jflsgw5f0p" />
      <Handle type="source" position={Position.Right} className="opacity-0" data-id="element-14755" data-mp="baz4jvm6w5od" />
    </div>;
});
GenreNode.displayName = 'GenreNode';